// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2GAhl","content":"ManualTimeModal_content__O-aWD"};